<ion-header>
  <ion-toolbar>
    <ion-title>Upload Site Photos - {{ site.name }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">Save &amp; Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Photos of Site</ion-card-title>
      <curbnturf-checked *ngIf="listingComplete.photosCompleted(mainFormValue)"></curbnturf-checked>
    </ion-card-header>
    <ion-card-content class="ion-no-padding">
      <div class="form-wrapper">
        <curbnturf-site-photos [autoSave]="false" [form]="form" [site]="site" (imageUpdated)="onImageUploaded()"> </curbnturf-site-photos>
      </div>
    </ion-card-content>
  </ion-card>
</ion-content>
